import ChipGroupRoot, { Props } from './ChipGroup'

export default function ChipGroup(props: Props) {
  return <ChipGroupRoot {...props} />
}

export type { Props } from './ChipGroup'
